import { FireIcon } from 'src/components/Icons/FireIcon'

import { useLastUnitsCounterFlag } from './useLastUnitsCounterFlag'

interface LastUnitsFlagProps {
  isLastUnits: boolean
  productId?: string
  isCartLayout?: boolean
  sectionClassName?: string
  textClassName?: string
  IconComponent?: React.ComponentType<{ color: string }>
}
export function LastUnitsFlag({
  isLastUnits,
  productId,
  isCartLayout = false,
  sectionClassName = '',
  textClassName = '',
  IconComponent = FireIcon,
}: LastUnitsFlagProps) {
  const { showCounterVersion, unitsLeft } = useLastUnitsCounterFlag(
    productId,
    isLastUnits
  )

  if (!isLastUnits) {
    return null
  }

  const sectionStyle =
    sectionClassName || (isCartLayout ? 'flex justify-center' : 'my-6')

  const textStyle = isCartLayout
    ? 'text-expressText text-font-size-2 leading-[18px] font-semibold pt-1'
    : 'text-[#E3262F] text-font-size-3 leading-[16.8px] font-medium'

  const flagText =
    showCounterVersion && unitsLeft !== null
      ? `Restam apenas ${unitsLeft} disponíveis`
      : 'Últimas unidades!'

  return (
    <section className={sectionStyle} data-dy-id="last-units-flag">
      <div className="flex items-center justify-center w-fit gap-1">
        <IconComponent color={isCartLayout ? '#DB6900' : '#E3262F'} />
        <p className={`${textStyle} ${textClassName}`}>{flagText}</p>
      </div>
    </section>
  )
}
